'use client';

import React from 'react';
import { Field } from '../ContactForm.types';
import { useContactForm } from '../useContactForm';
import { useValidationSchema } from './useValidationSchema';

const getFieldValue = (
	e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
	field: Field,
) => {
	switch (field.type) {
		case 'termsAndConditionsCheckbox':
			return 'checked' in e.target && e.target.checked ? field.value : '';
		default:
			return e.target.value;
	}
};

// Returns click and blur-handler for contact-form input fields
export const useInputProps = (field: Field) => {
	const [, dispatch] = useContactForm();

	const schema = useValidationSchema(field);

	return {
		onChange: (
			e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
		) => {
			dispatch({
				type: 'changeContactFormField',
				fieldName: field.name,
				fieldValue: getFieldValue(e, field),
				schema,
			});
		},
		onBlur: () => {
			dispatch({
				type: 'validateContactFormField',
				fieldName: field.name,
				schema,
			});
		},
	};
};
